import '../App.css';
import '../css/Nav design.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import RegisteredUserData from '../model/response/RegisteredUserData';
import { ToastContainer, toast } from "react-toastify";
import UserLogin from "../model/request/UserLogin";
import TopBarLogin from './TopBarLogin';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import Offeradd from './Offeradd';
import { getFCMToken } from "../utils/fcm";
import { requestForToken } from "../firebase";
import SaveFCMTokenRequest from '../model/request/Savefcmtoken';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {

  var userObject = new UserLogin();
  const navigation = useNavigate()
  var [username, setUsername] = useState("");
  var [usernameError, setusernameError] = useState()
  var [password, setPassword] = useState("")
  var [passwordError, setpasswordError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [fcmToken, setFcmToken] = useState("");
  const [downloadapk, setDownloadApk] = useState();

  const [showMobilePopup, setShowMobilePopup] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);

  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileError, setMobileError] = useState();
  const [otp, setOtp] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  async function clicktoViewpagescreen() {
    if (validation()) {

      if (!fcmToken) {
        setFcmToken("");
        // showToastFailed("FCM Token not generated");
        // return;
      }

      userObject.user_Name = await ApiConfig.encrypt(username);
      userObject.password = await ApiConfig.encrypt(password);
      userObject.fcmToken = fcmToken;

      loginAPICall();
    }
  }
  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  useEffect(() => {
    fetchFCMToken();
    const token = localStorage.getItem("token");

    if (token) {
      navigation("/Viewpage", { replace: true });
    }
  }, []);

  const fetchFCMToken = async () => {
    try {
      const permission = await Notification.requestPermission();
      // if (permission !== "granted") {
      // console.error("Notification permission denied by user.");
      // return;
      // }
      const token = await requestForToken();

      if (token) {
        console.log("FCM Token:", token);
        setFcmToken(token);
      }
    } catch (err) {
      console.log(err);
    }
  };

  async function loginAPICall() {

    console.log("Response:", JSON.stringify(userObject));

    try {
      const response = await axios.post(
        ApiConfig.getUrl("User/login"),
        JSON.stringify(userObject),
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      const api = ApiResponse.fromJson(response.data);

      if (api.statusCode == 200) {

        const login = RegisteredUserData.fromJson(api.response);

        showToast(api.message);

        localStorage.setItem("token", login.token);
        localStorage.setItem("loginVal", JSON.stringify(api.response));
        localStorage.setItem("gender", login.gender);

        console.log("Login Gender:", login.gender);
        await saveFCMToken(login.user_Id);

        setIsLoading(false);

        console.log("statusCode:", login.token);

        navigation('/Viewpage', {
          state: {
            userId: login.user_Id,
            is_Paid: login.is_Paid
          }
        });

      } else {
        setIsLoading(false);
        showToastFailed(api.errorMessage);
      }

    } catch (error) {
      setIsLoading(false);
      showToastFailed("Login Failed");
      console.error("Error:", error);
    }
  }
  async function saveFCMToken(userId) {

    const token = await requestForToken();

    if (!token) {
      console.log("FCM Token not Generate");
      return;
    }

    const request = new SaveFCMTokenRequest();

    request.user_Id = userId;
    request.fcmToken = token;
    request.deviceType = "WEB";

    console.log(request);

    axios.post(
      ApiConfig.getUrl("User/saveFCMToken"), // backend endpoint
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(res => {
        console.log("FCM Saved", res.data);
      })
      .catch(err => {
        console.log(err);
      });

  }

  function validation() {
    var isFlage = true
    {
      if (username == "") {
        setusernameError("Please Enter Your Username.")
        isFlage = false
      }
      else {
        setusernameError("")
      }
      if (password == "") {
        setpasswordError("Please Enter Your Password.")
        isFlage = false
      }
      else {
        setpasswordError("")
      }
      return isFlage;
    }

  }

  async function loginWithOtpAPICall() {

    const encryptedMobile = await ApiConfig.encrypt(mobileNumber);

    axios.post(
      ApiConfig.getUrl("User/loginWithOtp"),
      {
        mobileNumber: encryptedMobile, FcmToken: fcmToken
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(response => {

        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode === 200) {

          showToast(api.message);

          setShowMobilePopup(false);
          localStorage.setItem("token", api.response.token);
          localStorage.setItem("loginVal", JSON.stringify(api.response));

          navigation("/Loginviaotp", {
            state: {
              userId: api.response.user_Id,
              mobileNumber: encryptedMobile,
              mobile: mobileNumber,
              isOtpLogin: true
            }
          });

        } else {

          showToastFailed(api.errorMessage);

        }

      })
      .catch(error => {

        console.log(error);
        showToastFailed("Failed to send OTP");

      });

  }
  const handleClick = () => {
    window.open('https://drive.google.com/file/d/1kPhAxsI-zwHrVEp-zll4ckqZ6Z0ySucF/view?usp=drive_link', '_blank', 'noopener,noreferrer');
  };

  function AppdownloadAPICall() {

    setIsLoading(true);

    console.log("Response:", "response.data");
    axios.get(
      ApiConfig.getUrl("User/downloadapk"),
      {

        headers: {
          "Content-Type": "application/json",

        }
      }
    )
      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);

        if (api.statusCode == 200) {
          setDownloadApk(api.response);
          setIsLoading(false);

        }
      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed(error);
        // console.error("Error:", error);
      });
  }



  const handleLoginWithOtp = () => {
    if (!mobileNumber.trim()) {
      setMobileError("Please Enter Your Mobile Number");
      return;
    }

    if (!/^\d{10}$/.test(mobileNumber)) {
      setMobileError("Please Enter a valid 10 digit Mobile Number");
      return;
    }

    setMobileError("");
    loginWithOtpAPICall();
  };

  function clicktoforgotpassword() {
    navigation('/forgotpassword');
  }

  function clicktoVerify() {
    navigation('./Mobileverifypopup')
  }


 const disableRightClick = (e) => {
    if(ApiConfig.ENV == "PRD"){
    e.preventDefault();
    }
  };

  return (
    <>

      <div className='fullview'  onContextMenu={disableRightClick}  >
        <TopBarLogin />
        <ToastContainer />
        {isLoading && (
          <div className="loader-overlay">
            <Oval
              height={60}
              width={60}
              color="#ffffff"
              secondaryColor="#cccccc"
              strokeWidth={4}
              visible={true}
            />
          </div>
        )}
        <div className='container'>

          <div className='row mt-5 align-items-center gx-0'>
            <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
              <img className='image h-100 w-100' src={logo} alt='logo' />

            </div>

            <div className="col-lg-6 col-12 card  p-3">
              <p className="h5 text-center mt-2 pt-2" style={{ fontWeight: "bold" }}>Login</p>

              <label htmlFor="uname">Username </label>
              <input type="text" id="uname" placeholder="Email / Mobile Number" className="form-control mt-1 mb-2" onChange={(e) => setUsername(e.target.value)} />
              <span className="mb-2 text-danger text-decoration-none " style={{ letterSpacing: "1px" }}>{usernameError}</span>



              <label htmlFor="pass">Password</label>
              <div className="position-relative mb-2">
                <input
                  type={showPassword ? "text" : "password"}
                  id="pass"
                  placeholder="Password"
                  className="form-control pe-5 mt-1 mb-1"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d"
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <span className="text-danger text-decoration-none mb-2 " style={{ letterSpacing: "1px" }}>{passwordError}</span>


              <div className='d-flex' style={{ justifyContent: "space-between" }}>
                <label

                  style={{ cursor: "pointer", color: "var(--primary-color)" }}
                  onClick={() => setShowMobilePopup(true)}
                >
                  Login via OTP
                </label>
                {showMobilePopup && (
                  <div className="popup-overlay">
                    <div className="popup-card">

                      <h4>Enter your Registered Mobile Number</h4>

                      <input
                        type="text"
                        className="form-control mt-3"
                        placeholder="Enter Mobile Number"
                        value={mobileNumber}
                        maxLength={10}
                        onChange={(e) => {
                          setMobileNumber(e.target.value);
                          setMobileError("");
                        }}
                      />
                      <span className="text-danger text-decoration-none">{mobileError}</span>

                      <div className="d-flex justify-content-end mt-4">

                        <button
                          className="btn btn-secondary me-2"
                          onClick={() => setShowMobilePopup(false)}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}
                          onClick={handleLoginWithOtp}
                        >
                          Continue
                        </button>

                      </div>

                    </div>
                  </div>
                )}


                {showOtpPopup && (
                  <div className="popup-overlay">
                    <div className="popup-card">

                      <h4>OTP Verification</h4>

                      <input
                        type="text"
                        className="form-control mt-3"
                        placeholder="Enter OTP"
                        value={otp}
                        maxLength={6}
                        onChange={(e) => setOtp(e.target.value)}
                      />

                      <div className="d-flex justify-content-end mt-4">

                        <button
                          className="btn btn-secondary me-2"
                          onClick={() => setShowOtpPopup(false)}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}
                        >
                          Verify OTP
                        </button>

                      </div>

                    </div>
                  </div>
                )}
                <label className=' text-primary' style={{ cursor: "pointer" }} onClick={clicktoforgotpassword}>Forgot Password?</label>
              </div>



              <button onClick={clicktoViewpagescreen} type="button" className="btn w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}> Submit </button>


            </div>
            <span className='center fs-1' onClick={handleClick}>Download the App</span>


          </div>
          <Offeradd />
        </div>

      </div>

      {/* Why Choose Saral Matrimony */}
      <section className="why-matrimony-section mt-2 container">

        <div className="text-center mb-5">
          <div className="why-small-title">
            ◉ &nbsp; Why IndiaMetti Matrimony
          </div>

          <h2 className="why-title">
            Why Choose IndiaMetti Matrimony?
          </h2>

          <p className="why-subtitle">
            Four pillars that make us the trusted choice for Tamil families
            seeking a marriage alliance.
          </p>
        </div>

        <div className="row g-3 align-items-stretch">

          {/* Verified Profiles - Main Card */}
          <div className="col-lg-6 col-md-12">
            <div className="verified-card h-100">

              <div className="verified-icon">
                <i className="bi bi-people"></i>
              </div>

              <h3>Verified Profiles</h3>

              <p>
                Every matrimonial profile is carefully verified to help you connect
                with genuine brides and grooms across India.
              </p>

              <div className="verified-list">
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Mobile Number  verified
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Manual photo review
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Family-friendly
                </div>
              </div>

            </div>
          </div>

          {/* Right Side Cards */}
          <div className="col-lg-6 col-md-12">

            <div className="row g-3 h-100">

              {/* Secure */}
              <div className="col-md-6">
                <div className="why-feature-card h-100">

                  <div className="feature-icon secure-icon">
                    <i className="bi bi-lock"></i>
                  </div>

                  <h5>Secure &amp; Private</h5>

                  <p>
                    Your data is secure and protected
                  </p>

                </div>
              </div>

              {/* Advanced Search */}
              <div className="col-md-6">
                <div className="why-feature-card h-100">

                  <div className="feature-icon search-icon">
                    <i className="bi bi-search"></i>
                  </div>

                  <h5>Advanced Search</h5>

                  <p>
                    Find brides and grooms based on your preferences
                  </p>

                </div>
              </div>

              {/* Smart Matching */}
              <div className="col-md-6">
                <div className="why-feature-card h-100">

                  <div className="feature-icon heart-icon">
                    <i className="bi bi-heart"></i>
                  </div>

                  <h5>Smart Matching</h5>

                  <p>
                    Find your life partner for marriage with ease
                  </p>

                </div>
              </div>

              {/* Aadhaar */}
              <div className="col-md-6">
                <div className="why-feature-card h-100">

                  <div className="feature-icon aadhaar-icon">
                    <i className="bi bi-patch-check"></i>
                  </div>

                  <h5>Mobile Number Verified</h5>

                  <p>
                    Optional Mobile Number verification badge for added trust.
                  </p>

                </div>
              </div>

            </div>

          </div>

        </div>


        {/* Statistics */}
        <div className="row text-center why-stats mt-5 border">

          <div className="col-6 col-md-3">
            <div className="stat-number">100%</div>
            <div className="stat-label">Verified Profiles</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">50+</div>
            <div className="stat-label">Communities</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">28+</div>
            <div className="stat-label">Indian States</div>
          </div>

          <div className="col-6 col-md-3">
            <div className="stat-number">Quick</div>
            <div className="stat-label">Customer Support</div>
          </div>

        </div>
      </section>

      {/* Find Brides & Grooms by Location */}
      <section className="location-section mt-0 container">

        <div className="row align-items-start">

          {/* LEFT CONTENT */}
          <div className="col-lg-4 col-md-12">

            <div className="location-small-title">
              <i className="bi bi-geo-alt"></i>
              Serving Across India &amp; Worldwide
            </div>

            <h2 className="location-title">
              Find Brides &amp; Grooms
              <br />
              Everywhere
            </h2>

            <p className="location-description">
              Connect with genuine matrimonial profiles from all regions across India
              and abroad. Find brides and grooms based on your preferred Locations
              region, community, language, and lifestyle.
            </p>


            {/* 30+ Box */}


          </div>


          {/* RIGHT CONTENT */}
          <div className="col-lg-8 col-md-12 mt-1 mt-lg-0">

            <div className="row g-3">

              {/* Chennai */}
              <div className="col-6 col-md-3">
                <div className="city-card city-chennai">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>North India</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>


              {/* Madurai */}
              <div className="col-6 col-md-3">
                <div className="city-card city-madurai">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>South India</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>


              {/* Coimbatore */}
              <div className="col-6 col-md-3">
                <div className="city-card city-coimbatore">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>West India</h5>
                  <p>Matrimony Services</p>


                </div>
              </div>


              {/* Trichy */}
              <div className="col-6 col-md-3">
                <div className="city-card city-trichy">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>East India</h5>
                  <p>Matrimony Services</p>
                </div>
              </div>


              {/* Salem */}
              <div className="col-6 col-md-3">
                <div className="city-card city-salem">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>Central India</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>


              {/* Tirunelveli */}
              <div className="col-6 col-md-3">
                <div className="city-card city-tirunelveli">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-geo-alt"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>NRI / Abroad</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="city-card city-erode">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-globe2"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>All Regions</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>
              <div className="col-6 col-md-3">
                <div className="city-card city-chennai">

                  <div className="city-top">
                    <div className="city-icon">
                      <i className="bi bi-globe2"></i>
                    </div>

                    <i className="bi bi-arrow-right city-arrow"></i>
                  </div>

                  <h5>All Castes</h5>
                  <p>Matrimony Services</p>

                </div>
              </div>


              {/* <div className="cities-covered-box mt-5">

              <div className="covered-icon">
               
              </div>
              <div>
                <div className="covered-number">All Regions</div>
                <div className="covered-text">
                  Matrimony Services
                </div>
              </div>

            </div> */}


            </div>



          </div>
        </div>
      </section>

      {/* =========================================
    SARAL MATRIMONY SERVICES
========================================= */}

      <section className="services-section container">

        {/* Heading */}
        <div className="services-heading text-center">

          <div className="services-small-title">
            ✦ &nbsp; Our Services
          </div>

          <h2>
            IndiaMetti Matrimony Services
          </h2>
          <p>
            Complete matrimonial solutions designed to help individuals and
            families find meaningful marriage alliances across India.
          </p>

        </div>


        {/* Service Cards */}
        <div className="row g-4 mt-4">

          {/* =================================
        LOCATION SERVICE
    ================================= */}
          <div className="col-lg-6 col-md-12">

            <div className="service-card location-service">

              {/* Card Header */}
              <div className="service-card-header">

                <div className="service-icon">
                  <i className="bi bi-geo-alt"></i>
                </div>

                <div>
                  <div className="service-label">
                    LOCATION
                  </div>

                  <h3>
                    Matrimony Across India
                  </h3>
                </div>

              </div>


              {/* Content */}
              <div className="service-content">

                <p>
                  IndiaMetti Matrimony connects brides and grooms from cities, towns,
                  and communities across India. Whether you are looking for a life
                  partner in your own city or another part of the country, discover
                  genuine matrimonial profiles based on your preferences.
                </p>


                <div className="service-points">

                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Verified profiles from across India</span>
                  </div>

                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Community and language-based search</span>
                  </div>

                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Professional and educated profiles</span>
                  </div>

                </div>
              </div>

            </div>

          </div>


          {/* =================================
        PROFESSION SERVICE
    ================================= */}
          <div className="col-lg-6 col-md-12">

            <div className="service-card profession-service">

              {/* Card Header */}
              <div className="service-card-header">

                <div className="service-icon">
                  <i className="bi bi-briefcase"></i>
                </div>

                <div>

                  <div className="service-label">
                    PROFESSION
                  </div>

                  <h3>
                    Profession-Based Matrimony
                  </h3>

                </div>

              </div>


              {/* Content */}
              <div className="service-content">

                <p>
                  Find brides and grooms by profession and career preferences —
                  Engineering Matrimony, Doctor Matrimony, Teacher Matrimony,
                  IT Professional Matrimony, Government Employee Matrimony,
                  Business Professionals, and many more.
                </p>


                {/* Profession List */}
                <div className="profession-list">

                  <div className="profession-item engineer">
                    <i className="bi bi-code-slash"></i>
                    <span>Engineers</span>
                  </div>

                  <div className="profession-item doctor">
                    <i className="bi bi-heart-pulse"></i>
                    <span>Doctors</span>
                  </div>

                  <div className="profession-item teacher">
                    <i className="bi bi-book"></i>
                    <span>Teachers</span>
                  </div>

                  <div className="profession-item it">
                    <i className="bi bi-code"></i>
                    <span>IT Professionals</span>
                  </div>

                  <div className="profession-item business">
                    <i className="bi bi-building"></i>
                    <span>Business</span>
                  </div>

                  <div className="profession-item government">
                    <i className="bi bi-bank"></i>
                    <span>Government Jobs</span>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      <footer className='bg-dark text-white text-center'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>

  );
}
export default Login;